<div class="form-group">
    <div class="array-item">
        <div class="row">
            <div class="col-sm-10">
                <div class="array-header"><i>Number of items: {{datafieldGroups.length}}</i></div>
            </div>
            <div class="col-sm-2">
                <i [hidden]="!allowAddItem()" (click)="addItem()" class="array-item-button dx-icon-plus"></i>
            </div>
        </div>

        @for (group of datafieldGroups; track group; let i = $index) {
            <hr>

            <div class="row">
                <div class="col-sm-10">
                    <label>{{datafield.DisplayName}} - {{i+1}}</label>
                </div>
                <div class="col-sm-2">
                    <i [hidden]="!allowRemoveItem()" (click)="removeItem(i)" class="array-item-button dx-icon-minus"></i>
                </div>
            </div>

            @for (field of group.DataFields; track field) {
                @if (!field.IsHidden) {
                    <div class="array-field">
                        <label [title]="field.InfoText">
                            {{field.DisplayName}}{{field.IsRequired && field.DataType.DataTypeEnum !== 'CheckBox' ? ' *' : ''}}
                        </label>
                        <br />
                        @switch (field.DataType.DataTypeEnum) {
                            @case ('TextBox') {
                                <ep-datafield-textbox #datafieldComponent [datafield]="field" [isAlwaysEditable]="isAlwaysEditable" [formValidationGroup]="formValidationGroup" (valueChanged)="onValueChanged($event)"></ep-datafield-textbox>
                            }
                            @case ('CheckBox') {
                                <ep-datafield-checkbox #datafieldComponent [datafield]="field" [isAlwaysEditable]="isAlwaysEditable" [formValidationGroup]="formValidationGroup" (valueChanged)="onValueChanged($event)"></ep-datafield-checkbox>
                            }
                            @case ('DropDown') {
                                <ep-datafield-dropdown #datafieldComponent [datafield]="field" [isAlwaysEditable]="isAlwaysEditable" [formValidationGroup]="formValidationGroup" (valueChanged)="onValueChanged($event)"></ep-datafield-dropdown>
                            }
                            @case ('Password') {
                                <ep-datafield-password #datafieldComponent [datafield]="field" [isAlwaysEditable]="isAlwaysEditable" [formValidationGroup]="formValidationGroup" (valueChanged)="onValueChanged($event)"></ep-datafield-password>
                            }
                            @case ('File') {
                                <ep-datafield-file-upload #datafieldComponent [datafield]="field" [isAlwaysEditable]="isAlwaysEditable" [formValidationGroup]="formValidationGroup" (valueChanged)="onValueChanged($event)"></ep-datafield-file-upload>
                            }
                            @case ('XmlArtifact') {
                                <ep-datafield-artifact-xml-picker #datafieldComponent [datafield]="field" [isAlwaysEditable]="isAlwaysEditable" [formValidationGroup]="formValidationGroup" (valueChanged)="onValueChanged($event)"></ep-datafield-artifact-xml-picker>
                            }
                            @case ('AssemblyArtifact') {
                                <ep-datafield-artifact-assembly-picker #datafieldComponent [datafield]="field" [isAlwaysEditable]="isAlwaysEditable" [formValidationGroup]="formValidationGroup" (valueChanged)="onValueChanged($event)"></ep-datafield-artifact-assembly-picker>
                            }
                            @case ('XPath') {
                                <ep-datafield-xpath #datafieldComponent [datafield]="field" [isAlwaysEditable]="isAlwaysEditable" [formValidationGroup]="formValidationGroup" (valueChanged)="onValueChanged($event)"></ep-datafield-xpath>
                            }
                            @default {
                                <span class="text-muted">Unsupported type: {{field.DataType.DataTypeEnum}}</span>
                            }
                        }
                    </div>
                }
            }
        }

    </div>
    @if (!isValid) {
        <div class="error">{{ errorText }}</div>
    }
</div>
